import { Injectable } from '@angular/core';
import { RestService } from '../rest/rest.service';
import { GenericTreeNode } from '../../components/generic-tree/generic-tree-node';
import { EntityType, Endpoint } from '../../models/enums';
import { View } from '../../models/view';

@Injectable()
export class CommonWithRestService {

    constructor(private restService: RestService) {
    }

    public enableDisableWordListOptions(item: GenericTreeNode): void {
        if (item.data && item.contextMenuOptions) {
            const handle = item.entityType === EntityType.savedSearch || item.data.view instanceof View ? item.data.view.handle : item.data.handle;
            const viewWordListOption = item.contextMenuOptions.find(o => o.name === 'View Word List ...');
            const calculateWordListOption = item.contextMenuOptions.find(o => o.name === 'Calculate Word List');
            if ((viewWordListOption || calculateWordListOption) && handle) {
                if (viewWordListOption) {
                    viewWordListOption.enabled = false;
                }
                if (calculateWordListOption) {
                    calculateWordListOption.enabled = false;
                }
                this.restService.post(Endpoint.viewManager_getView, { handle: handle, selectedAttributes: [] }).then(responseGetView => {
                    let wordListAvailable = false;
                    const attributeObject = responseGetView && responseGetView.view && responseGetView.view.attributes ?
                        responseGetView.view.attributes.find(f => f.name === 'wordListAvailable') : null;
                    if (attributeObject) {
                        wordListAvailable = true;
                    }
                    if (viewWordListOption) {
                        viewWordListOption.enabled = wordListAvailable;
                    }
                    if (calculateWordListOption) {
                        calculateWordListOption.enabled = responseGetView?.view?.documentCount > 0 ? !wordListAvailable : false;
                    }
                });
            }
        }
    }

}
